import {
  CaseSummaryLine,
  resolveCaseDetails,
  useCaseAccountTypes,
  useCaseTypes,
  useFetchCaseConfig,
  useProject,
} from '@/modules/projects'

export const CaseSummary = () => {
  useFetchCaseConfig()
  const project = useProject()
  const caseTypes = useCaseTypes()
  const accountTypes = useCaseAccountTypes()

  const detailEntries = project
    ? resolveCaseDetails(project, { caseTypes, accountTypes })
    : []

  return (
    <div className="space-y-3">
      <h3 className="text-[13px] font-medium text-ink-subtle">Case details</h3>
      <CaseSummaryLine />
      {detailEntries.length > 0 && (
        <dl className="space-y-2 text-sm">
          {detailEntries.map((entry) => (
            <div key={entry.key} className="flex gap-2">
              <dt className="text-ink-subtle">{entry.label}:</dt>
              <dd className="text-right font-medium">{entry.value}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  )
}
